<div id="side-menu">
  <div class="logo">
    <img
      src="/assets/images/sollo-logo.svg"
      alt="Sollo Business"
      draggable="false"
    />
  </div>

  <div class="mobile-menu" (click)="showMenu()">
    <mat-icon class="mat-18">menu</mat-icon>
  </div>

  <div class="menu" #menu>
    <mat-icon class="mat-20 close" (click)="hideMenu()" id="close"
      >highlight_off</mat-icon
    >
    <ul>
      <li>
        <div
          class="item-holder"
          [routerLink]="['/dashboard']"
          routerLinkActive="link-active"
        >
          <img
            src="../../../../assets/images/icon/dashboard.svg"
            alt="Dashboard"
            draggable="false"
          />
          {{ 'DASHBOARD.dashboard' | translate }}
        </div>
      </li>
      <li>
        <div
          class="item-holder"
          [routerLink]="['/cards']"
          routerLinkActive="link-active"
        >
          <img
            src="../../../../assets/images/icon/card.svg"
            alt="Cartoes"
            draggable="false"
          />
          {{ 'DASHBOARD.cards' | translate }}
        </div>
      </li>
      <li>
        <div
          class="item-holder"
          [routerLink]="['/contacts']"
          routerLinkActive="link-active"
        >
          <img
            src="../../../../assets/images/icon/contacts.svg"
            alt="Contatos"
            draggable="false"
          />
          {{ 'DASHBOARD.contacts' | translate }}
        </div>
      </li>
      <li>
        <div
          class="item-holder"
          [routerLink]="['/settings']"
          routerLinkActive="link-active"
        >
          <img
            src="../../../../assets/images/icon/settings.svg"
            alt="Ajustes"
            draggable="false"
          />
          {{ 'DASHBOARD.settings' | translate }}
        </div>
      </li>
      <li class="mobile-only" (click)="onSignOut()">
        <div class="item-holder">
          <mat-icon class="mat-18">logout</mat-icon>
          {{ 'DASHBOARD.signout' | translate }}
        </div>
      </li>
    </ul>
  </div>

  <div class="menu logout">
    <ul>
      <li (click)="onSignOut()">
        <div class="item-holder">
          <mat-icon class="mat-18">logout</mat-icon>
          {{ 'DASHBOARD.signout' | translate }}
        </div>
      </li>
    </ul>
  </div>
</div>
